export default __webpack_public_path__ + "static/operators-86cc0414fe79a8b20550747473afd4e6.png";